import React, { useState } from 'react';

import { useDebouncedValue, useDisclosure } from '@mantine/hooks';
import { AthleteRetrieve } from 'types';

import AthleteDocumentsFilters from './components/AthleteDocumentsFilters';
import AthleteDocumentsTable from './components/AthleteDocumentsTable';
import ContractCreateModal from './components/ContractCreateModal';
import DocumentSignModal from './components/DocumentSignModal';
import WaiverCreateModal from './components/WaiverCreateModal';
import { AthleteDocumentSearchFilters } from './types';

const Documents = ({
  athlete,
  permission = true,
}: {
  athlete: AthleteRetrieve;
  permission?: boolean;
}): JSX.Element => {
  const initialFilterValues = {
    athleteId: athlete.athleteId,
    search: '',
    type: null,
    isSigned: null,
  };

  const [searchFilters, setSearchFilters] = useState<AthleteDocumentSearchFilters>(initialFilterValues);
  const [debouncedSearchFilters] = useDebouncedValue<AthleteDocumentSearchFilters>(searchFilters, 250);
  const [isCreateWaiverOpened, { toggle: handleCreateWaiverToggle }] = useDisclosure(false);
  const [isCreateContractOpened, { toggle: handleCreateContractToggle }] = useDisclosure(false);
  const [isSignModalOpened, { toggle: handleSignModalToggle }] = useDisclosure(false);
  const [documentId, setDocumentId] = useState<string>('');

  const handleSignModalClose = (): void => {
    handleSignModalToggle();
    setDocumentId('');
  };

  return (
    <>
      <AthleteDocumentsFilters
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        initialFilterValues={initialFilterValues}
        openCreateWaiver={handleCreateWaiverToggle}
        openCreateContract={handleCreateContractToggle}
        permission={permission}
      />

      <AthleteDocumentsTable
        searchFilters={debouncedSearchFilters}
        openSignModal={handleSignModalToggle}
        setDocumentId={setDocumentId}
        permission={permission}
      />

      <ContractCreateModal
        opened={isCreateContractOpened}
        closeHandler={handleCreateContractToggle}
        athlete={athlete}
      />

      <WaiverCreateModal
        athlete={athlete}
        opened={isCreateWaiverOpened}
        closeHandler={handleCreateWaiverToggle}
      />

      <DocumentSignModal
        opened={isSignModalOpened}
        closeHandler={handleSignModalClose}
        documentId={documentId}
        permission={permission}
      />
    </>
  );
};

export default Documents;
